module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h4', {
    attrs: {
      "for": "expiration-date"
    }
  }, [_vm._v("設定有效期限")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expirationDate),
      expression: "expirationDate"
    }],
    staticClass: "form-control custom-input",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "type": "date",
      "id": "expiration-date",
      "readonly": _vm.editable === false
    },
    domProps: {
      "value": (_vm.expirationDate)
    },
    on: {
      "click": _vm.popPad,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.expirationDate = $event.target.value
      }
    }
  }), _c('DateInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPad),
      expression: "showPad"
    }],
    attrs: {
      "defaultDate": _vm.expirationDate,
      "limitedDate": _vm.limitedDate
    },
    on: {
      "saveDate": _vm.saveDate,
      "closePad": _vm.closePad
    }
  })], 1), _c('div', {
    staticClass: "button-wrap"
  }, [_c('button', {
    staticClass: "btn btn-lg confirm-button",
    on: {
      "click": _vm.setExpirationDate
    }
  }, [_vm._v("確認")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c79249ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/DateSelection.vue
// module id = 1543
// module chunks = 1